module.exports = __webpack_public_path__ + "static/media/t04kz.f15d5019.pdf";